import React, { useState, useEffect, useRef } from "react";
import { API_URL } from '../../config';

const ProjetsHome = () => {
    const [projets, setProjets] = useState([]);
    const [showModal, setShowModal] = useState(false);
    const [selectedProject, setSelectedProject] = useState(null);
    const [isClosing, setIsClosing] = useState(false);
    const modalRef = useRef(null);

    useEffect(() => {
        fetch(`${API_URL}/videos/home`)
            .then((res) => res.json())
            .then((data) => setProjets(data));
    }, []);

    function getEmbedUrl(url) {
        const vimeoMatch = url.match(/vimeo\.com\/(\d+)/);
        if (vimeoMatch) return 'https://player.vimeo.com/video/' + vimeoMatch[1] + '?autoplay=1';
        const youtubeMatch = url.match(/(?:youtube\.com\/watch\?v=|youtu\.be\/)([a-zA-Z0-9_-]+)/);
        if (youtubeMatch) return 'https://www.youtube.com/embed/' + youtubeMatch[1] + '?autoplay=1';
        return url;
    }

    const handleProjectClick = (project) => {
        setSelectedProject(project);
        setShowModal(true);
        setIsClosing(false);
        document.body.classList.add('lock');
    };

    const closeModal = () => {
        setIsClosing(true);
        setTimeout(() => {
            setShowModal(false);
            setSelectedProject(null);
            setIsClosing(false);
            document.body.classList.remove('lock');
        }, 400);
    };

    const handleCloseModal = (event) => {
        if (modalRef.current && !modalRef.current.contains(event.target)) {
            closeModal();
        }
    };

    useEffect(() => {
        const handleKeyDown = (e) => {
            if (e.key === 'Escape' && showModal) closeModal();
        };
        window.addEventListener('keydown', handleKeyDown);
        return () => window.removeEventListener('keydown', handleKeyDown);
    }, [showModal]);

    return (
        <div className="container-projetshome xl:p-28 min-[320px]:p-4 min-[320px]:py-20 flex flex-col justify-center items-center">
            <div className="flex justify-center items-center flex-col">
                <h2 className="xl:text-5xl xl:pb-28 min-[320px]:pb-9 font-bold min-[320px]:text-center min-[320px]:text-4xl">
                    Nos projets<span>.</span>
                </h2>
                <a className="link-real self-end btn-arrow" href="/realisations">Voir toutes les réalisations</a>
                <div className="container-projects">
                    {projets.videos?.map((projet) => (
                        <div
                            key={projet.id}
                            className="card-projet relative"
                            onClick={() => handleProjectClick(projet)}
                        >
                            <img alt="cover du projet" src={`${projet.thumbnail}`} />
                            <h2 className="absolute text-3xl bottom-6 px-4">{projet.title}</h2>
                        </div>
                    ))}
                </div>
            </div>

            {showModal && selectedProject && (
                <div
                    className={`reals-modal-overlay ${isClosing ? 'closing' : ''}`}
                    onClick={handleCloseModal}
                >
                    <div className="reals-modal-box" ref={modalRef}>
                        <div className="reals-modal-iframe-wrapper">
                            <iframe
                                src={getEmbedUrl(selectedProject.url)}
                                frameBorder="0"
                                allow="autoplay; fullscreen"
                                allowFullScreen
                            />
                        </div>
                        <div className="reals-modal-bottom">
                            <div className="reals-modal-info">
                                <h3>{selectedProject.title}</h3>
                                {selectedProject.description && (
                                    <p className="modal-description">{selectedProject.description}</p>
                                )}
                                {selectedProject.category_name && (
                                    <span className="modal-category">{selectedProject.category_name}</span>
                                )}
                            </div>
                            <button onClick={closeModal} className="reals-modal-close" />
                        </div>
                    </div>
                </div>
            )}
        </div>
    );
};

export default ProjetsHome;